'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'poo';
var width = 512;
var height = 512;
var aliases = [128169];
var unicode = 'f2fe';
var svgPathData = 'M224 0c-9.7 0-18.5 5.8-22.2 14.8S200.2 34.1 207 41l7.4 7.4c6.1 6.1 9.5 14.4 9.5 23l0 3.2c0 16.2-13.1 29.3-29.3 29.3l-17.8 0c-6.1 0-12.1 .8-17.8 2.2-45.2 9.6-79.1 49.7-79.1 97.8 0 1.1 0 2.2 .1 3.3-33 14-56.1 46.6-56.1 84.7 0 14.3 3.3 27.8 9.1 39.9-20.3 19-33.1 46-33.1 76.1 0 57.4 46.6 104 104 104l304 0c57.4 0 104-46.6 104-104 0-30.1-12.8-57.1-33.1-76.1 5.8-12.1 9.1-25.6 9.1-39.9 0-38.1-23.1-70.7-56.1-84.7 0-1.1 .1-2.2 .1-3.3 0-38-21.2-71-52.3-87.9-16.1-66.6-76.1-116.1-147.7-116.1l-8 0zm48 71.4c0-5.5-.6-10.9-1.6-16.1 33.8 13.4 58.9 44 64.5 81 1.3 8.6 7.2 15.9 15.3 18.9 19.8 7.4 33.8 26.5 33.8 48.7 0 4.9-.7 9.7-1.9 14.1-1.9 6.7-.8 13.9 3 19.7s10 9.7 16.9 10.6c21.5 2.9 38 21.3 38 43.6 0 11.4-4.3 21.8-11.4 29.6-5 5.4-7.1 12.9-5.9 20.1s5.7 13.6 12.2 17.1c17.4 9.5 29.2 28 29.2 49.2 0 30.9-25.1 56-56 56l-304 0c-30.9 0-56-25.1-56-56 0-21.2 11.7-39.7 29.2-49.2 6.5-3.5 10.9-9.8 12.2-17.1s-1-14.7-5.9-20.1c-7.1-7.8-11.4-18.2-11.4-29.6 0-22.3 16.6-40.7 38-43.6 6.9-.9 13-4.8 16.9-10.6s4.9-13 3-19.7c-1.3-4.5-1.9-9.2-1.9-14.1 0-25.1 17.8-46 41.4-50.9 .4-.1 .8-.2 1.2-.3 2-.5 4.1-.8 6.3-.8l17.8 0c42.7 0 77.3-34.6 77.3-77.3l0-3.2zM192 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM172.3 352c-6.8 0-12.3 5.5-12.3 12.3 0 2.4 .7 4.8 2.2 6.7 8.2 10.5 39.5 45 93.8 45s85.6-34.6 93.8-45c1.5-1.9 2.2-4.3 2.2-6.7 0-6.8-5.5-12.3-12.3-12.3l-167.4 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPoo = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;